import Vue from "vue";

export default {
    install () {
        Vue.prototype.$statusDesigner = function(item) {
            let isFreelancer = '';
            if (item.requestMethod == 1) {
                isFreelancer = 'freelancerText';
            } else if (item.requestMethod == 2) {
                isFreelancer = 'saleText';
            }
            const isAdmin = localStorage.getItem('isAdmin') === 'true' ? true : false;
            if (isAdmin) {
                return 'readText' + ' ' + isFreelancer;
            }

            return (item.designerReadStatus === 0 ? 'unreadText' : 'readText') + ' ' + isFreelancer;
        };

        Vue.prototype.$statusSale = function(item) {
            let isFreelancer = '';
            if (item.requestMethod == 1) {
                isFreelancer = 'freelancerText';
            } else if (item.requestMethod == 2) {
                isFreelancer = 'saleText';
            }
            const isAdmin = localStorage.getItem('isAdmin') === 'true' ? true : false;
            if (isAdmin) {
                return 'readText' + ' ' + isFreelancer;
            }

            return (item.saleReadStatus === 0 ? 'unreadText' : 'readText') + ' ' + isFreelancer;
        };

        Vue.prototype.$statusAccountant = function(item) {
            let isFreelancer = '';
            if (item.requestMethod == 1) {
                isFreelancer = 'freelancerText';
            } else if (item.requestMethod == 2) {
                isFreelancer = 'saleText';
            }
            const isAdmin = localStorage.getItem('isAdmin') === 'true' ? true : false;
            if (isAdmin) {
                return 'readText' + ' ' + isFreelancer;
            }

            return (item.accountantReadStatus === 0 ? 'unreadText' : 'readText') + ' ' + isFreelancer;
        };

        Vue.prototype.$statusShip = function(item) {
            let isFreelancer = '';
            if (item.requestMethod == 1) {
                isFreelancer = 'freelancerText';
            } else if (item.requestMethod == 2) {
                isFreelancer = 'saleText';
            }
            const isAdmin = localStorage.getItem('isAdmin') === 'true' ? true : false;
            if (isAdmin) {
                return 'readText' + ' ' + isFreelancer;
            }

            return (item.shipReadStatus === 0 ? 'unreadText' : 'readText') + ' ' + isFreelancer;
        };

        Vue.prototype.$updateDesignRequestByUser = async function(requestId, requestBody) {
            const isAdmin = localStorage.getItem('isAdmin') === 'true' ? true : false;
            if (isAdmin) {
                return false;
            }
            try {
                const response = await this.$http.put(process.env.VUE_APP_DESIGN_RESQUEST_API + requestId + '/readStatus', requestBody);

                if (response.data && response.data.success) {
                    return true;
                } else {
                    return false;
                }
            } catch (e) {
                return false;
            }
        };

        Vue.prototype.$updateManufactureRequestByUser = async function(requestId, requestBody) {
            const isAdmin = localStorage.getItem('isAdmin') === 'true' ? true : false;
            if (isAdmin) {
                return false;
            }

            try {
                const response = await this.$http.put(process.env.VUE_APP_MANUFACTURE_RESQUEST_API + requestId + '/readStatus', requestBody);
                if (response.data && response.data.success) {
                    return true;
                } else {
                    return false;
                }
            } catch (e) {
                return false;
            }
        };
    },
};